export const DEFAULT_ANIMATION_SPEED_MS = 0.3;